import { render, staticRenderFns } from "./Shifts.container.vue?vue&type=template&id=3a820308&scoped=true&"
import script from "./Shifts.container.vue?vue&type=script&lang=js&"
export * from "./Shifts.container.vue?vue&type=script&lang=js&"
import style0 from "./Shifts.container.vue?vue&type=style&index=0&id=3a820308&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a820308",
  null
  
)

export default component.exports